import { Flex, LicencePlate, smBumps } from '@wrisk/ui-components'
import { default as React, FunctionComponent } from 'react'

import { toVehicleDescriptionVIN } from '../../../domain'
import { tDefaults } from '../../../infrastructure/internationalisation'
import { VehicleInputValueVRN } from '../inputs'
import { Formatter } from '../types'

export const VehicleFormatterVRN: FunctionComponent<Formatter<VehicleInputValueVRN>> = ({
  value,
  size,
  t,
}) =>
  value?.specification ? (
    <Flex columnGap={smBumps} justifyContent='flex-start'>
      {value?.vrn && size !== 'small' && (
        <LicencePlate licencePlate={value.vrn} size='small' />
      )}
      <span>{toVehicleDescriptionVIN(value.specification)}</span>
    </Flex>
  ) : (
    t(tDefaults('inputs.no-answer'))
  )
